export const OnboardedDriftForSales = 'onboardedDriftForSales'
